// @flow @format
import {put, take, select} from 'redux-saga/effects';
import {PrivateApi} from 'lib/cloner-api';
import {
	addRepositories,
	FETCH_REPOSITORIES,
} from '../reducers/entities/repositories';

import type {Repository} from 'lib/cloner-api';
import type {State} from '../reducers';
import type {FetchRepositoriesAction} from '../reducers/entities/repositories';

function makeSaga(api: PrivateApi) {
	return function*(): Generator<*, void, *> {
		while (true) {
			const action: FetchRepositoriesAction = yield take(
				FETCH_REPOSITORIES
			);
			const state: State = yield select();

			if (state.entities.repositories.byMachine[action.machineId]) {
				continue;
			}

			try {
				const repos: Repository[] = yield api.getRepositoriesByMachine(
					action.machineId,
					action.user
				);
				yield put(addRepositories(action.machineId, repos || []));
			} catch (error) {
				console.error(error);
			}
		}
	};
}

export default makeSaga;



// WEBPACK FOOTER //
// ./src/sagas/repositories.js